import { trackings } from '@xingternal/platform-layout-trackings';
import { withTracking } from '@xingternal/xing-tracking';
import { HeaderLoggedIn as HeaderLoggedInComponent } from './HeaderLoggedIn';
/*
 *  CONNECT WITH FRAME DATA
 */
const HeaderLoggedIn = withTracking(trackings)(HeaderLoggedInComponent);
export { HeaderLoggedIn };
//# sourceMappingURL=HeaderLoggedIn.container.js.map